<template>
  <div class="col-xs-12 col-md-12">
    <div class="row">  
      <div v-for="(indicator,index) in componentListIndicators">

        <div v-for="(condition,index) in indicator.colorConditions">

          <div v-if="indicator.value >= condition.minValue & indicator.value < condition.maxValue">

            <div v-if="indicator.width=='Small'" class="col-lg-2">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="indicator.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{indicator.value}}</span> <span class="h6 text-white-op">{{indicator.label[actualLanguage]}}</span>
                    </div>
                </a>
            </div>



            <div v-if="indicator.width=='Medium'" class="col-lg-3">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="indicator.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{indicator.value}}</span> <span class="h6 text-white-op">{{indicator.label[actualLanguage]}}</span>
                    </div>
                </a>
            </div>


            <div v-if="indicator.width=='Large'" class="col-lg-4">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="indicator.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{indicator.value}}</span> <span class="h6 text-white-op">{{indicator.label[actualLanguage]}}</span>
                    </div>
                </a>
            </div>


            <div v-if="indicator.width=='Full'" class="col-lg-12">
                <a class="block block-link-hover3">
                    <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:condition.colorBackground}">
                        <i v-bind:class="indicator.favIcon" class="fa-2x text-white pull-right"></i>
                        <span class="h6 font-w700 text-white-op">{{indicator.value}}</span> <span class="h6 text-white-op">{{indicator.label[actualLanguage]}}</span>
                    </div>
                </a>
            </div>
        </div>

      </div>

      </div>
    </div>


  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'

export default {
  props: ['componentListIndicators'], //tableau : {label,varName,value,agregation,favIcon}

  data() {
    return {
      actualLanguage : "FR",
      testColor : '#46c37b'
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData']),
  },
  watch: {


  },
  methods: {
  

    },



  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'} 

  },



}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ApiDeviceListIndicatorV1p00.vue?41f5496f